import React from 'react'
import { Tag, TagProps, Tooltip } from '@arco-design/web-react'
import IconTrophy from '@/assets/trophy.svg'
import IconArrowRight from '@/assets/ic_arrow_right_rank.svg'
import styles from './style/index.module.less'

interface Props extends TagProps {
  type: 'ranking' | 'certificate' | 'rating'
  name?: string
  value?: string
  desc?: string
  onClick?: () => void
}

function EchoTag({ type, name, value, desc, onClick, style }: Props) {
  const styleMap = {
    certificate: {
      icon: '',
      color: '#655AEC',
      borderColor: '#ADA0EF',
      backgroundColor: '#F3F1FD',
      suffix: ''
    },
    rating: {
      icon: '',
      color: '#655AEC',
      borderColor: '#ADA0EF',
      backgroundColor: '#F3F1FD',
      suffix: ''
    },
    ranking: {
      icon: <IconTrophy />,
      color: '#ED9F07',
      borderColor: '#FCBF28',
      backgroundColor: '#FFF1CE',
      suffix: <IconArrowRight />
    }
  }

  const styleObj = styleMap[type] || styleMap['ranking']

  return (
    <Tag
      key={name}
      icon={styleObj?.icon ? <span style={{ display: 'flex', alignItems: 'center' }}>{styleObj?.icon}</span> : null}
      bordered
      className={styles['container']}
      style={{
        color: styleObj?.color,
        borderColor: styleObj?.borderColor,
        backgroundColor: styleObj?.backgroundColor,
        cursor: onClick ? 'pointer' : 'default',
        ...style
      }}
      onClick={() => {
        onClick?.()
      }}
    >
      <Tooltip content={desc}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {name}
          {value}
          {styleObj?.suffix}
        </div>
      </Tooltip>
    </Tag>
  )
}

export default EchoTag
